import { ProjectResponse } from "../../../types/project";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export const getProjectsByOrganisation = async (
  organisationUuid: string,
  page: number = 0,
  size: number = 20,
  search?: string
): Promise<ProjectResponse> => {
  try {
    const { data } = await axiosInstance.get<{ response: ProjectResponse }>(
      `/pmo/get-all-projects-by-organisation/${organisationUuid}`,
      { params: { page, size, search } }
    );
    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
